(function () {
    'use strict';

    angular.module('swif.achats')

    .service('AchatsService', AchatsService)
    .service('swifAchatsService', swifAchatsService);

    function AchatsService($q, $sce, $location, swif) {
        'ngInject';
        var service = {};

        service.rights = {};
        service.rights.getPermissions = function () {
            var user = swif.user.getAuthenticatedUserData();
            function right (perm) {
                return _.contains(user.access_rights, perm);
            }
            var ret = {};
            ret.consumable_request  = {
                claimer: right('consumable_request_claimer'),
                supervisor: right('consumable_request_manager'),
                manager: right('consumable_stock_manager')
            };
            ret.purchase = {
                claimer: right('purchase_order_ask_create'),
                supervisor: right('purchase_order_ask_read_all'),
                manager: right('purchase_order_ask_read_all')
            };
            ret.quotation = {
                claimer: right('purchase_order_create'),
                supervisor: right('purchase_order_read_all'),
                manager: right('purchase_order_read_all'),
            };
            ret.manager = {
                stock: right('stock_config'),
                account: right('account_config'),
                purchase: right('purchase_config')
            };
            return ret;
        };

        service.formatName = function (product) {
            var label = "";
            var fa_class = product.is_stock ? 'fa-industry' : 'fa-shopping-cart';
            label += "<i class='fa "+ fa_class +"' aria-hidden='true'></i> ";
            label += product.name;

            return $sce.trustAsHtml(label);
        };

        service.product = {};
        service.product.fetchFromConsumablesCart = function (productFields) {
            var consumables = swif.cart.getCartItems('consumable_stock');
            if (consumables.length > 0) {
                // first, retrieve product_ids from consumables
                var filter = {fields: ['product_id']};
                swif.data.addFilter(filter, 'id', 'in', _.pluck(consumables, 'id'));
                return swif.data.get('consumable_stock', undefined, filter)
                .then(function (res) {
                    // then, retrieve products using product_id[0] of each consumable
                    var product_ids = [];
                    _.forEach(res, function (item) {
                        product_ids.push(item.product_id[0]);
                    });
                    var fields = _.union(['name', 'complete_name'], productFields || []);
                    var filter2 = {fields: fields};
                    swif.data.addFilter(filter2, 'id', 'in', product_ids);
                    return swif.data.get('product', undefined, filter2);
                });
            } else {
                var ret = $q.defer();
                ret.resolve([]);
                return ret.promise;
            }
        };
        service.product.emptyConsumablesCart = function () {
            swif.cart.emptyCart('consumable_stock');
        };
        service.product.parseLocationForAction = function () {
            var ret = {
                contentType: '',
                category: '',
                actionId: ''
            };
            // parse location to see if 'doAction' is in search params
            // 'doAction=list.add', or 'doAction=add' are the same
            var doActionParam = $location.search().doAction;
            if (doActionParam) {
                // remove the doAction from url (avoid to call again the action)
                $location.search('doAction', null);
                // and dispatch the action
                var action = doActionParam.split('.');
                // if only actionId is specified, expects a list action
                if (action.length === 1) {
                    ret.category = 'list';
                    ret.actionId = action[0];
                } else if (action.length === 2) {
                    ret.category = action[0];
                    ret.actionId = action[1];
                }
            }
            return ret;
        };

        service.filters = {};
        service.filters.getProductFilter = function (filter, userServiceIds) {
            if (filter.fields) {
                filter.fields.push('product_id');
            }
            swif.data.addFilter(filter, 'product_id.type_prod', 'in', ['fourniture']);
            swif.data.searchRead('consumable', filter).then(
                function(consumables){
                    swif.data.addFilter(filter, '|');
                    swif.data.addFilter(filter, 'type_id.service_ids', '=', false);    // Getting consumable without service ids for everyone
                    swif.data.addFilter(filter, 'type_id.service_ids', 'in', userServiceIds);
                }
            );
        };


        service.filters.getWarehouseFilter = function (filter) {
            var ids = swif.user.getAuthenticatedUserData().warehouse_ids || [];
            swif.data.addFilter(filter, 'id', 'in', ids);
        };

        service.formatters = {};
        service.formatters.m2o = function (val) {
            return val ? val[0]: false;
        };

        service.tax = {};
        service.tax.lastData = {};
        service.tax.format = function (tax) {
            var amount = tax.amount * 100.0;
            return amount.toFixed(2).toString() + '%';
        };
        service.tax.getDefault = function (taxes) {
            return _.find(taxes, {amount: 0.20});
        };
        service.tax.fetchChoices = function () {
            var filter = {fields: ['id', 'amount', 'price_include']};
            swif.data.addFilter(filter, 'price_include', '=', false);
            swif.data.addFilter(filter, 'type_tax_use', '=', 'purchase');
            // filter on VAT type taxes, OR CGF imported taxes if CirilGestionFinancière is installed
            if (swif.module.modules.opengst_civil) {
                // swif.data.addFilter(filter, '|');
                swif.data.addFilter(filter, 'civil_code', '!=', false);
            }
            // swif.data.addFilter(filter, 'base_code_id.parent_id.code', '=', 'c)');
            swif.data.sortOn(filter, 'amount');
            return swif.data.get('account_tax',undefined,filter)
            .then(function (data) {
                _.forEach(data, function (item) {
                    item.name = service.tax.format(item);
                });
                service.tax.lastData = data;
                return data;
            });
        };
        return service;
    }

    function swifAchatsService(
        AchatsService,
        AchatsBudgetsService,
        AchatsStocksConfigurationService,
        consumableStockMoveService,
        PurchaseService,
        QuotationService,
        ConsumableStockService,
        ConsumableRequestService
    ) {
        var service = {
            common: AchatsService,
            budget: AchatsBudgetsService,
            configuration: AchatsStocksConfigurationService,
            consumable_stock_move: consumableStockMoveService,
            purchase: PurchaseService,
            quotation: QuotationService,
            consumable_stock: ConsumableStockService,
            request: ConsumableRequestService
        };
        return service;
    }

})();
